// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__37DwU","log":"ModalInventoryLogs_log__gVp6G","date":"ModalInventoryLogs_date__2f61N","userName":"ModalInventoryLogs_userName__1Co5W"};